var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import SoundsList from './SoundsList';
import * as uuid from 'uuid';
import { useDeepCompareEffect } from '../../hooks/useDeepCompare';
import { isEqual } from 'lodash';
import * as hash from 'object-hash';
import { TagFilter } from '../TagFilter';
import { FilterWrapper, onTagClick } from '../..';
import { BPMSoundsGeneric } from '../../generic';
import { errorToString } from "bpm-client-api";
import * as toastr from 'toastr';
function hasFilter(props) {
    return 'filter' in props;
}
function ManagedSoundList(props, syncStyle) {
    var _a;
    var firstDefaultFilter = React.useRef(hasFilter(props) ? props.filter : {});
    var _b = React.useState(), sounds = _b[0], setSounds = _b[1];
    var _c = React.useState(false), invisible = _c[0], setInvisible = _c[1];
    var _d = React.useState(true), loading = _d[0], setLoading = _d[1];
    var _e = React.useState(props.defaultLimit || 20), limit = _e[0], setLimit = _e[1];
    var _f = React.useState(1), page = _f[0], setPage = _f[1];
    var _g = React.useState(0), filterHeight = _g[0], setFilterHeight = _g[1];
    var _h = React.useState(false), forceToggle = _h[0], setForceToggle = _h[1];
    var loadingToken = React.useRef();
    var soundList = React.useRef(null);
    var _j = React.useState(hasFilter(props) ? props.filter : {}), filter = _j[0], _setFilter = _j[1];
    var _k = React.useState(hash.MD5(__assign(__assign({}, (hasFilter(props) ? props.filter : {})), { keyType: undefined, showHalfTime: undefined, sort_by: undefined }))), tagHashFilter = _k[0], setTagHashFilter = _k[1];
    var _l = React.useState([]), tags = _l[0], setTags = _l[1];
    var tagLoadingToken = React.useRef();
    var setFilter = (function (cb) {
        if (typeof cb === 'function') {
            _setFilter(function (filter) {
                return __assign(__assign({}, cb(filter)), firstDefaultFilter.current);
            });
        }
        else {
            _setFilter(function (filter) {
                return __assign(__assign(__assign({}, filter), cb), firstDefaultFilter.current);
            });
        }
    });
    useDeepCompareEffect(function () {
        if (hasFilter(props) && !isEqual(props.filter, filter)) {
            setFilter(props.filter);
        }
    }, hasFilter(props) ? [props.filter] : []);
    useDeepCompareEffect(function () {
        setTagHashFilter(hash.MD5(__assign(__assign({}, filter), { keyType: undefined, showHalfTime: undefined, sort_by: undefined })));
        if (hasFilter(props)) {
            props.onFilterChange && props.onFilterChange(filter);
        }
    }, [filter]);
    React.useEffect(function () {
        tagLoadingToken.current = uuid.v4();
        BPMSoundsGeneric.get().loadTags && BPMSoundsGeneric.get().loadTags(__assign(__assign({}, filter), { requireSoundCount: true }), tagLoadingToken.current).then(function (_a) {
            var tags = _a.data, token = _a.token;
            if (tagLoadingToken.current == token) {
                setTags(tags);
            }
        });
    }, [tagHashFilter]);
    useDeepCompareEffect(function () {
        loadingToken.current = uuid.v4();
        setLoading(true);
        if (hasFilter(props)) {
            props.apiFunc(filter, { skip: (page - 1) * limit, limit: limit }, loadingToken.current).then(function (_a) {
                var data = _a.data, pagination = _a.pagination, token = _a.token;
                if (loadingToken.current == token || !token) {
                    setSounds({ data: data, paging: pagination });
                    setLoading(false);
                    setInvisible(false);
                }
            }).catch(function (err) {
                errorToString(err).forEach(function (err) { return toastr.error(err); });
            });
        }
        else {
            props.apiFunc({ skip: (page - 1) * limit, limit: limit }, loadingToken.current).then(function (_a) {
                var data = _a.data, pagination = _a.pagination, token = _a.token;
                if (loadingToken.current == token || !token) {
                    setSounds({ data: data, paging: pagination });
                    setLoading(false);
                    setInvisible(false);
                }
            }).catch(function (err) {
                errorToString(err).forEach(function (err) { return toastr.error(err); });
            });
        }
    }, [filter, limit, page, forceToggle]);
    var onKeyClick = function (key) {
        if (filter.key == key) {
            setFilter(function (filter) {
                return __assign(__assign({}, filter), { key: undefined });
            });
        }
        else {
            setFilter(function (filter) {
                return __assign(__assign({}, filter), { key: key });
            });
        }
    };
    return React.createElement("div", { className: 'ManagedSoundlist ' + (invisible ? 'temp-invisible' : '') + (syncStyle ? 'syncStyles' : '') },
        React.createElement("div", { className: filterHeight < (window.innerHeight / 2 - 68) ? 'sticky' : '' },
            hasFilter(props) && !props.hideTagFilter && React.createElement(TagFilter, { onHeightChange: function (height) {
                    setFilterHeight(height);
                }, tags: tags, onTagClick: function (tag) {
                    onTagClick(tag, filter, setFilter);
                }, selectedTags: filter.tags }), (_a = soundList.current) === null || _a === void 0 ? void 0 :
            _a.renderHeader(),
            hasFilter(props) && React.createElement(FilterWrapper, { tags: tags, filter: filter, onFilterUpdated: function (filter) {
                    setFilter(filter);
                } })),
        React.createElement("div", { className: 'sticky-target' }),
        React.createElement(SoundsList, __assign({ ref: soundList }, props, { sounds: sounds === null || sounds === void 0 ? void 0 : sounds.data, loading: loading, filter: filter, onFilterChange: hasFilter(props) ? function (newFilter) {
                if (hasFilter(props)) {
                    setFilter(function (filter) {
                        return __assign(__assign({}, filter), newFilter);
                    });
                }
            } : undefined, onKeyClick: onKeyClick, onTagClick: function (tag) {
                onTagClick(tag, filter, setFilter);
            }, onBPMClick: function (bpm) {
                setFilter(function (filter) {
                    return __assign(__assign({}, filter), { bpm_max: bpm, bpm_min: bpm });
                });
            }, paging: sounds === null || sounds === void 0 ? void 0 : sounds.paging, onLoadMore: function (limitOrPage, force, isPaging) {
                if (!isPaging) {
                    if (limitOrPage == limit && force) {
                        setForceToggle(!forceToggle);
                    }
                    else {
                        setLimit(limitOrPage);
                    }
                }
                else {
                    setInvisible(true);
                    setPage(limitOrPage);
                }
            }, context: props.context })));
}
export default ManagedSoundList;
//# sourceMappingURL=ManagedSoundList.js.map